import { useIsJCUser } from '@hooks/user.hook';
import React from 'react';

const ExamResultBanner = () => {
  const { isJC } = useIsJCUser({ subjectId: undefined, generalPage: true });
  return (
    <div
      className={`badges-banner flex relative rounded-xl ${
        isJC === false
          ? "bg-[url('/public/img/exam-result/banner.svg')] h-[88px] md:mt-[19px]"
          : "bg-[url('/public/img/exam-result/jc-banner.svg')] h-[125px] -mt-[21px]"
      } bg-no-repeat bg-cover max-md:bg-center text-white z-20 max-md:mt-0 max-lg:mt-4 px-3 mb-6`}
    >
      {isJC === false && (
        <>
          <div
            className="
              badges-banner-illustration
              relative
              bg-[-10px]
              bottom-0
              bg-cover
              bg-no-repeat
              bg-[url('/public/img/exam-result/boy-figure.svg')]
              w-[120px]
              h-[96px]
              mt-[-8px]
              max-md:hidden
            "
          ></div>
          <div
            className="
              badges-banner-illustration-2
              bg-contain
              bg-no-repeat
              bg-[url('/public/img/exam-result/bubble.svg')]
              bg-center
              w-[127px]
              h-[70px]
              max-xl:hidden
              mr-4
              ml-auto
              my-auto
            "
          ></div>
        </>
      )}
    </div>
  );
};

export default ExamResultBanner;
